<ng-container *ngIf="viewModel$ | async as viewModel">
  <span [pTooltip]="viewModel.tooltip" tooltipPosition="bottom">
    <button
      class="p-m-1 p-button-outlined workorders-btn-outlined"
      pButton
      label="Add Event"
      (click)="menu.toggle($event)"
      [disabled]="viewModel.disabled"
      icon="pi pi-plus"
    ></button>
  </span>
  <p-menu
    #menu
    [popup]="true"
    appendTo="body"
    [model]="viewModel.addableEventTypes"
  >
    <ng-template pTemplate="item" let-item>
      <a
        pRipple
        class="p-menuitem-link"
        [class.event-type-disabled]="item.isDisabled"
        [style.display]="'flex'"
        [style.justify-content]="'space-between'"
        [style.align-items]="'center'"
        [attr.aria-disabled]="item.isDisabled"
        [attr.tabindex]="item.isDisabled ? -1 : 0"
        (click)="
          item.isDisabled ||
            store.dispatch(
              actions.eventTypeMenuItemSelected({
                eventType: item.eventType,
                eventId: generateEventId(),
              })
            )
        "
      >
        <span class="p-menuitem-text">{{ item.label }}</span>
        <i
          *ngIf="item.validationTooltip"
          class="pi pi-exclamation-triangle"
          tabindex="0"
          role="button"
          style="
            color: #f97316;
            margin-left: 0.5rem;
            cursor: pointer;
            position: relative;
            z-index: 1;
          "
          [pTooltip]="item.validationTooltip"
          (mousedown)="
            $event.stopPropagation();
            store.dispatch(
              actions.fixLocationsLinkClicked({ eventType: item.eventType })
            )
          "
          (touchstart)="
            $event.stopPropagation();
            store.dispatch(
              actions.fixLocationsLinkClicked({ eventType: item.eventType })
            )
          "
          (keydown.enter)="
            $event.stopPropagation();
            store.dispatch(
              actions.fixLocationsLinkClicked({ eventType: item.eventType })
            )
          "
          (keydown.space)="
            $event.stopPropagation();
            store.dispatch(
              actions.fixLocationsLinkClicked({ eventType: item.eventType })
            )
          "
        ></i>
      </a>
    </ng-template>
  </p-menu>
</ng-container>
